/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_ActiveInputs */

const en_templates_active = /** @type {(inputs: Templates_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const he_templates_active = /** @type {(inputs: Templates_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פעיל`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Templates_ActiveInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_active = /** @type {((inputs?: Templates_ActiveInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_ActiveInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_active(inputs)
	return he_templates_active(inputs)
});